import { TrashIcon } from "@heroicons/react/24/solid";
import classNames from "classnames";
import React from "react";
import { Table as BTable } from "react-bootstrap";
import CurrencyInput from "react-currency-input-field";
import { IconButton } from "..";
import { Tooltip } from "../tooltip";
import classes from "./Table.module.scss";

export const Table = ({
  sameColumnWidth = false,
  headers,
  rows,
  editable,
  children,
  footer,
  onDelete,
  onFieldChanged,
  hideHeader = false,
  horizontal = false,
}) => {
  const tableCell = (
    cellValue,
    cellId,
    rowData,
    rows,
    rowIndex,
    header,
    hasBorderTop = false,
    deletable = false,
    onDelete
  ) => {
    const {
      editable: fieldEditable,
      type = "text",
      className,
      tooltip,
      ...props
    } = (rowData.props || {})[cellId] || {};
    const isEditable = editable || fieldEditable;

    const Wrapper = tooltip ? Tooltip : React.Fragment;
    const WrapperProps = tooltip ? { title: tooltip } : {};
    return (
      <Wrapper {...WrapperProps} key={cellId}>
        <td
          className={classNames(
            `text-${header?.align || props.align || "left"}`,
            className,
            {
              "border-top-black": hasBorderTop,
              "bg-white": isEditable,
              [classes["editable"]]: isEditable,
            }
          )}
          {...props}
        >
          {isEditable ? (
            type === "currency" ? (
              <CurrencyInput
                prefix="$ "
                value={cellValue}
                placeholder={"input here"}
                className="text-align-inherit bg-white"
                onValueChange={(v) => {
                  onFieldChanged(rowIndex, cellId, v);
                }}
                {...props}
              />
            ) : (
              <input
                type={type}
                defaultValue={cellValue}
                placeholder={"input here"}
                className="text-align-inherit bg-white"
                onChange={(e) => {
                  onFieldChanged(rowIndex, cellId, e.target.value);
                }}
              />
            )
          ) : typeof cellValue === "function" ? (
            cellValue(rowData, rows)
          ) : (
            cellValue
          )}
          {deletable && (
            <IconButton
              tabIndex={-1}
              className={classes["deleteButton"]}
              interactive={false}
              onClick={() => {
                onDelete();
              }}
            >
              <TrashIcon className="icon-md text-red" />
            </IconButton>
          )}
        </td>
      </Wrapper>
    );
  };

  const tableRow = (
    rowItem,
    index,
    rows,
    isFooter = false,
    hasBorderTop = false
  ) => {
    let cells = headers.map((property) => property.id);
    const deletable = rowItem?.props?.deletable;
    const tooltip = rowItem?.props?.tooltip;
    const Wrapper = tooltip ? Tooltip : React.Fragment;
    const WrapperProps = tooltip ? { title: tooltip } : {};

    return (
      <Wrapper {...WrapperProps} key={rowItem.uid || rowItem.id}>
        <tr
          className={classNames({
            "fw-bold": isFooter,
          })}
        >
          {cells.map((cellId, i) => {
            if (rowItem?.props && rowItem?.props[cellId]) {
              if (rowItem?.props[cellId].colSpan > 0) {
                for (let x = 1; x <= rowItem?.props[cellId].colSpan - 1; x++) {
                  cells[i + x] = undefined;
                }
              }
            }
            if (cellId)
              return tableCell(
                rowItem[cellId],
                cellId,
                rowItem,
                rows,
                index,
                headers.find((header) => header.id === cellId),
                hasBorderTop,
                deletable && i === cells.length - 1,
                () => onDelete(index)
              );
            return null;
          })}
        </tr>
      </Wrapper>
    );
  };

  return (
    <BTable
      bordered
      className={classNames(classes["wrapper"], {
        [classes["sameWidth"]]: sameColumnWidth,
        [classes["no-header"]]: hideHeader,
        [classes["horizontal"]]: horizontal,
      })}
      role={"table"}
    >
      <thead>
        <tr>
          {headers.map((item, i) => {
            const { tooltip } = item;
            const Wrapper = tooltip ? Tooltip : React.Fragment;
            const WrapperProps = tooltip
              ? { title: tooltip, placement: "top" }
              : {};
            return (
              <Wrapper {...WrapperProps} key={i}>
                <th
                  key={item.id}
                  className={classNames(
                    "fw-bold",
                    `text-${item.align || "left"}`
                  )}
                >
                  {item.title}
                </th>
              </Wrapper>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {children ||
          (rows || []).map((rowItem, i) => tableRow(rowItem, i, rows))}
        {(footer || []).map((rowItem, i) =>
          tableRow(rowItem, i, footer || [], true, i === 0, footer)
        )}
      </tbody>
    </BTable>
  );
};
